import * as React from "react";
import { UitkDialogAnimationType, UitkFullscreenDialog } from "uitk-react-dialog";
import { ToolbarType, UitkToolbar } from "uitk-react-toolbar";
import { LinksDialogContext } from "components/flexComponents/Links/GridView/LinkDialogContext";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import Links from "components/flexComponents/Links/Links";

interface LinkDialogProps {
  id: string;
  onDismiss: () => void;
}

export const LinkDialog = (props: LinkDialogProps) => {
  const { id, onDismiss } = props;
  const linksDialogContext = LinksDialogContext;

  const keyHelper = new ItemKeyHelper(`LinkDialog-${id}`);

  const dialogProps = {
    dialogShow: true,
    animation: UitkDialogAnimationType.SLIDEUP,
  };

  const toolBarAttributes = {
    type: ToolbarType.CLOSE,
    header: linksDialogContext.dialogHeading,
    iconLabel: "Close",
  };

  return (
    <UitkFullscreenDialog {...dialogProps}>
      <div className="uitk-cell">
        <UitkToolbar {...toolBarAttributes} action={onDismiss} />
      </div>
      <div className="LinkDialog uitk-scroll-vertical all-t-padding-one all-y-margin-one all-x-margin-one">
        {linksDialogContext.modules.map((module) => (
          <Links key={keyHelper.next()} flexTemplateNode={module} insideTabGroupParam />
        ))}
      </div>
    </UitkFullscreenDialog>
  );
};
